import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tenant, CreateTenantRequest, UpdateTenantRequest } from '../models/tenant.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAllTenants(): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(`${this.API_URL}/tenants`);
  }

  getTenantById(id: string): Observable<Tenant> {
    return this.http.get<Tenant>(`${this.API_URL}/tenants/${id}`);
  }

  getTenantBySlug(slug: string): Observable<Tenant> {
    return this.http.get<Tenant>(`${this.API_URL}/tenants/slug/${slug}`);
  }

  createTenant(tenant: CreateTenantRequest): Observable<Tenant> {
    return this.http.post<Tenant>(`${this.API_URL}/tenants`, tenant);
  }

  updateTenant(id: string, tenant: UpdateTenantRequest): Observable<Tenant> {
    return this.http.patch<Tenant>(`${this.API_URL}/tenants/${id}`, tenant);
  }

  deleteTenant(id: string): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/tenants/${id}`);
  }

  activateTenant(id: string): Observable<Tenant> {
    return this.http.patch<Tenant>(`${this.API_URL}/tenants/${id}/activate`, {});
  }

  deactivateTenant(id: string): Observable<Tenant> {
    return this.http.patch<Tenant>(`${this.API_URL}/tenants/${id}/deactivate`, {});
  }

  getTenantStats(id: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/tenants/${id}/stats`);
  }

  setTenantPassword(tenantId: string, password: string): Observable<any> {
    return this.http.patch(`${this.API_URL}/tenants/${tenantId}/set-password`, { password });
  }
}
